import React, { useEffect , useState } from 'react';
import Brands from '../components/Brands';
import Projects from '../components/Projects';
 import Hero from '../components/Hero';
import About from '../components/About';

import Contact from '../components/Contact';
import Engagements from '../components/Engagements';



export default function Home() {
    const [homePageData, setHomePageData] = useState(null);
    const [loading, setLoading] = useState(true);


    useEffect(() => {
        const fetchHomePageData = async () => {
            try {
                const response = await fetch("https://api.zplayer.app/web_content"); // Replace with your API endpoint
                if (!response.ok) {
                    throw new Error("Failed to fetch data");
                }
                const { error, result, message } = await response.json();

                if (error) {
                    console.error("API Error:", message);
                    throw new Error(message);
                }

                setHomePageData(result); // Use the `result` field from the response
            } catch (error) {
                console.error("Error fetching homepage data:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchHomePageData();
    }, []);
    if (loading) {
        return <div> </div>; // Display a loading indicator while fetching data
    }

    if (!homePageData) {
        return <div> </div>; // Handle case when data is null or undefined
    }

    const {
        hero,
        socialBtns,
        brands,
        about, engagements, socialBtnReseller,
        projects,
        contact,
    } = homePageData;

    return (
    <>
      <Hero data={hero} socialData={socialBtns} />
      <Brands data={brands} />
      <About data={about} />
      <Engagements data={engagements} socialData={socialBtnReseller} />
      <Projects data={projects} />
       <Contact data={contact} socialData={socialBtns} />
    </>
  );
}
